<template>
  <div>
    <el-table :data="filteredData" stripe border style="width: 100%">


      <!-- 一级表头：产品料号 -->
      <el-table-column label="产品型号" align="center" header-cell-class-name="first-level-header">
        <el-table-column prop="productName" align="center" min-width="120">
          <template #default="{ row }">
            <router-link
                :to="{
          name: 'ProductInfo',
          params: {
            id: row.id,
            modelType:row.type
          }
        }"
                class="a-style">
              {{ row.productName }}
            </router-link>
          </template>
        </el-table-column>
      </el-table-column>

      <!-- 一级表头：描述 -->
      <el-table-column label="描述" align="center" header-cell-class-name="first-level-header">
        <el-table-column prop="productRemark" align="center" min-width="160" />
      </el-table-column>

      <!-- 一级表头：Memory -->
      <el-table-column label="Memory" align="center" header-cell-class-name="first-level-header">
        <el-table-column prop="capacity" label="Capacity" align="center" min-width="100" />
        <el-table-column prop="chipManufacturer" label="Chip Manufacturer" align="center" min-width="150" />
        <el-table-column prop="chipOragnrzation" label="Chip Organization" align="center" min-width="140" />
        <el-table-column prop="feature" label="Feature" align="center" min-width="120" />
        <el-table-column prop="manufacturer" label="Manufacturer" align="center" min-width="140" />
        <el-table-column prop="operatingTemperature" label="Operating Temperature" align="center" min-width="180" />
      </el-table-column>

    </el-table>

    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
    </el-pagination>
  </div>

</template>
<script>
import {listProduct} from "@/utils/http";

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    search: {
      type: String,
      default: ''
    },
    t: {
      type: Function, // 通常是函数
      required: false
    },
    currentLang: {
      type: String,
      default: ''
    },
    modelType: {
      type: [String, Number], // 根据实际情况也可以只写 Number
      default: 0
    },
    searchKeyword: {
      type: [String], // 根据实际情况也可以只写 Number
      default: null
    }
  },
  created() {
    this.modelType = this.$route.params.type || 0; // 从路由获取
    console.log("这个值:"+this.modelType)
    this.searchKeyword = this.$route.query.search;
    console.log("子类:"+this.searchKeyword)
    this.initProductList();
  },
  data() {
    return {
      tableData: [
        {
          productName: 'HIGX-1234',
          productRemark: 'Micron 2400MHz 16GB',
          capacity: '16GB',
          chipManufacturer: 'MICRON',
          chipOragnrzation: '1 G x 8',
          feature: 'Low Power',
          manufacturer: 'Micron',
          operatingTemperature: '-40~85℃'
        },
        {
          productName: 'HIGX-1234',
          productRemark: 'Micron 2400MHz 16GB',
          capacity: '16GB',
          chipManufacturer: 'MICRON',
          chipOragnrzation: '1 G x 8',
          feature: 'Low Power',
          manufacturer: 'Micron',
          operatingTemperature: '-40~85℃'
        }
      ],
      params:{
        eType:0,
        type:0
      },
      currentPage: 1,    // 当前页码
      pageSize: 10,      // 每页显示条目数
      total: 0,
    }
  },


  computed: {
    filteredData() {
      let data = this.tableData

      // 搜索关键词过滤
      if (this.search) {
        const keyword = this.search.toLowerCase()
        data = data.filter(item =>
            Object.values(item).some(val =>
                String(val).toLowerCase().includes(keyword)
            )
        )
      }

      // 容量
      if (this.filters.capacity && this.filters.capacity.length) {
        data = data.filter(item => this.filters.capacity.includes(item.capacity))
      }

      // 芯片厂商
      if (this.filters.chipManufacturer && this.filters.chipManufacturer.length) {
        data = data.filter(item => this.filters.chipManufacturer.includes(item.chipManufacturer))
      }

      // Chip Organization
      if (this.filters.chipOragnrzation && this.filters.chipOragnrzation.length) {
        data = data.filter(item => this.filters.chipOragnrzation.includes(item.chipOragnrzation))
      }

      // Feature
      if (this.filters.feature && this.filters.feature.length) {
        data = data.filter(item => this.filters.feature.includes(item.feature))
      }

      // Manufacturer
      if (this.filters.manufacturer && this.filters.manufacturer.length) {
        data = data.filter(item => this.filters.manufacturer.includes(item.manufacturer))
      }

      // Operating Temperature
      if (this.filters.operatingTemperature && this.filters.operatingTemperature.length) {
        data = data.filter(item => this.filters.operatingTemperature.includes(item.operatingTemperature))
      }

      return data
    }

  },
  watch: {
    currentLang(newVal, oldVal) {
      this.onLangChange(newVal);
    },

  },
  methods: {
    initProductList() {
      if(this.searchKeyword){
        const param={
          productName:this.searchKeyword,
          productRemark:this.searchKeyword
        }

        listProduct(param).then(response => {
          this.tableData = response.rows;
          this.total = response.total; // 确保后端返回总条数
        })
      }else{
        this.params.type = this.modelType;
        this.params.pageNum = this.currentPage; // 添加页码参数
        this.params.pageSize = this.pageSize;   // 添加每页大小参数

        listProduct(this.params).then(response => {
          this.tableData = response.rows;
          this.total = response.total; // 确保后端返回总条数
        })
      }

    },

    // 分页大小改变事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.initProductList();
    },

    // 当前页改变事件
    handleCurrentChange(val) {
      this.currentPage = val;
      this.initProductList();
    },
    onLangChange(lang) {
      if(lang==='zh'){
        this.params.eType=0;
      }else{
        this.params.eType=1;
      }
      this.initProductList();
    },
  }
}
</script>
<style scoped>
::v-deep .el-table__header-wrapper thead.is-group > tr > th {
  background-color: #34689B !important;
  color: white !important;
}

.el-pagination {
  margin-top: 20px;
  text-align: right;
}

/* ✅ 手机端响应式适配 */
@media screen and (max-width: 768px) {
  /* 表格允许横向滚动，防止列过多挤压 */
  .el-table {
    overflow-x: auto;
    display: block;
    width: 100%;
  }

  /* 保证每列都有最小宽度 */
  ::v-deep .el-table__body-wrapper td {
    white-space: nowrap;
  }

  /* 分页按钮适配手机宽度 */
  .el-pagination {
    flex-wrap: wrap;
    justify-content: center;
    font-size: 12px;
    text-align: center;
  }

  /* 分页每页条数选择框字体缩小 */
  ::v-deep .el-pagination__sizes {
    font-size: 12px;
  }

  /* 分页总数文字适配 */
  ::v-deep .el-pagination__total {
    font-size: 12px;
    margin-bottom: 5px;
  }
}
</style>

